import { render, staticRenderFns } from "./newsletterDS.vue?vue&type=template&id=52c0245a"
import script from "./newsletterDS.vue?vue&type=script&lang=js"
export * from "./newsletterDS.vue?vue&type=script&lang=js"
import style0 from "./newsletterDS.vue?vue&type=style&index=0&id=52c0245a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports